import { render } from "./ztn-dialog.vue?vue&type=template&id=019593f9&scoped=true"
import script from "./ztn-dialog.vue?vue&type=script&lang=js"
export * from "./ztn-dialog.vue?vue&type=script&lang=js"

import "./ztn-dialog.vue?vue&type=style&index=0&id=019593f9&scoped=true&lang=css"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019593f9"]])

export default __exports__